module.exports = __webpack_public_path__ + "static/media/logoQualiRepar.d1244ccd.png";